<template>
  <div class="proceso-detalle">
    <template v-if="proceso.tieneMaquina">
      <el-row :gutter="12">
        <el-col
          :xs="12"
          :sm="8"
          :md="6"
        >
          <div class="data-item">
            <span class="data-label">Netos</span>
            <span class="data-value">{{ dv(proceso.metrosLinealesNetos, 'm') }}</span>
          </div>
        </el-col>
        <el-col
          :xs="12"
          :sm="8"
          :md="6"
        >
          <div class="data-item">
            <span class="data-label">Buenos</span>
            <span class="data-value">{{
              dv(proceso.metrosLinealesBuenos, unidadTrabajo.abreviaturaUnidadCantidad)
            }}</span>
          </div>
        </el-col>
        <el-col
          :xs="12"
          :sm="8"
          :md="6"
        >
          <div class="data-item">
            <span class="data-label">Totales</span>
            <span class="data-value">{{
              dv(proceso.metrosTotales, unidadTrabajo.abreviaturaUnidadCantidad)
            }}</span>
          </div>
        </el-col>
        <el-col
          :xs="12"
          :sm="8"
          :md="6"
        >
          <div class="data-item">
            <span class="data-label">Velocidad</span>
            <span class="data-value">{{
              dv(proceso.velocidadLinea ?? proceso.velocidad, unidadVelocidad(unidadTrabajo), 0)
            }}</span>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col
          v-if="!proceso.esGrupo"
          :xs="12"
          :sm="8"
          :md="6"
        >
          <div class="data-item">
            <span class="data-label">Merma fija</span>
            <span class="data-value merma-text">{{ dv(proceso.mermaFija, unidadMermaFija) }}</span>
          </div>
        </el-col>
        <el-col
          v-if="proceso.mermaColor > 0"
          :xs="12"
          :sm="8"
          :md="6"
        >
          <div class="data-item">
            <span class="data-label">Merma Color</span>
            <span class="data-value merma-text">{{
              dv(proceso.mermaColor, unidadTrabajo.abreviaturaUnidadCantidad)
            }}</span>
          </div>
        </el-col>
        <el-col
          v-if="proceso.mermaPolimero > 0"
          :xs="12"
          :sm="8"
          :md="6"
        >
          <div class="data-item">
            <span class="data-label">{{ labelsMatriz.merma }}</span>
            <span class="data-value merma-text">{{
              dv(proceso.mermaPolimero, unidadTrabajo.abreviaturaUnidadCantidad)
            }}</span>
          </div>
        </el-col>
        <el-col
          v-if="!proceso.esGrupo"
          :xs="12"
          :sm="8"
          :md="6"
        >
          <div class="data-item">
            <span class="data-label">Merma %</span>
            <span class="data-value merma-text">
              {{ dp((proceso.mermaPorcentual || 0) / 100) }}
              <span
                v-if="proceso.mermaPorcentualAbsoluta > 0"
                class="merma-absoluta"
              >
                ({{ dv(proceso.mermaPorcentualAbsoluta, unidadTrabajo.abreviaturaUnidadCantidad) }})
              </span>
            </span>
          </div>
        </el-col>

        <el-col
          :xs="12"
          :sm="8"
          :md="6"
        >
          <div class="data-item">
            <span class="data-label">Merma total</span>
            <span class="data-value merma-text merma-bold">{{
              dv(proceso.mermaTotal, unidadTrabajo.abreviaturaUnidadCantidad)
            }}</span>
          </div>
        </el-col>
        <el-col
          v-if="proceso.esImpresion"
          :xs="12"
          :sm="8"
          :md="6"
        >
          <div class="data-item">
            <span class="data-label">Tipo</span>
            <span class="data-value text-impresion">Impresión</span>
          </div>
        </el-col>
      </el-row>

      <div
        v-if="proceso.esGrupo && proceso.procesos && proceso.procesos.length > 0"
        class="merma-desglose"
      >
        <span class="setup-label">Merma por proceso :</span>
        <div
          v-for="proc in proceso.procesos"
          :key="proc.codigoCotizacionElementoProceso"
          class="merma-desglose-item"
        >
          <span class="merma-desglose-nombre">{{ proc.descripcion }}</span>
          <span class="merma-desglose-valor">
            Fija: <strong>{{ dv(proc.mermaFija, resolverAbreviaturaMermaFija(proc)) }}</strong>
          </span>
          <span class="merma-desglose-valor">
            {{ dp((proc.mermaPorcentual || 0) / 100) }}
            <span
              v-if="proc.mermaPorcentualAbsoluta > 0"
              class="merma-absoluta"
            >
              ({{ dv(proc.mermaPorcentualAbsoluta, resolverAbreviaturaUnidadRecurso(proc)) }})
            </span>
          </span>
          <span
            v-if="proc.mermaColor > 0"
            class="merma-desglose-valor"
          >
            Color:
            <strong>{{ dv(proc.mermaColor, resolverAbreviaturaUnidadRecurso(proc)) }}</strong>
          </span>
          <span
            v-if="proc.mermaPolimero > 0"
            class="merma-desglose-valor"
          >
            {{ labelsMatriz.merma }}:
            <strong>{{ dv(proc.mermaPolimero, resolverAbreviaturaUnidadRecurso(proc)) }}</strong>
          </span>
          <span class="merma-desglose-valor merma-desglose-total">
            Total:
            <strong>{{ dv(proc.mermaTotal, resolverAbreviaturaUnidadRecurso(proc)) }}</strong>
          </span>
        </div>
      </div>

      <el-row :gutter="12">
        <el-col
          :xs="12"
          :sm="8"
          :md="6"
        >
          <div class="data-item">
            <span class="data-label">Horas producción</span>
            <span class="data-value">{{ formatearHoras(proceso.horasProduccion) }}</span>
          </div>
        </el-col>
        <el-col
          :xs="12"
          :sm="8"
          :md="6"
        >
          <div class="data-item">
            <span class="data-label">Total Horas de Setup + Recarga</span>
            <span class="data-value">{{ formatearHoras(proceso.horasSetupTotal) }}</span>
          </div>
        </el-col>
        <el-col
          :xs="12"
          :sm="8"
          :md="6"
        >
          <div class="data-item">
            <span class="data-label">Total Horas</span>
            <span
              class="data-value"
              style="color: #409eff"
            >
              {{ formatearHoras(proceso.horasTotalesLinea) }}
            </span>
          </div>
        </el-col>
        <el-col
          v-if="proceso.divideBocas"
          :xs="12"
          :sm="8"
          :md="6"
        >
          <div class="data-item">
            <span class="data-label">Divide bocas</span>
            <span class="data-value">{{ `Sí (×${proceso.factorCortes})` }}</span>
          </div>
        </el-col>
      </el-row>

      <div
        v-if="tieneDetalleSetup(proceso.horasSetupDetalle)"
        class="setup-detalle"
      >
        <span class="setup-label">Detalle setup:</span>
        <span
          v-if="esValido(proceso.horasSetupDetalle.ajuste)"
          class="setup-item"
        >
          Ajuste: {{ formatearHoras(proceso.horasSetupDetalle.ajuste) }}
        </span>
        <span
          v-if="esValido(proceso.horasSetupDetalle.color)"
          class="setup-item"
        >
          Color: {{ formatearHoras(proceso.horasSetupDetalle.color) }}
        </span>
        <span
          v-if="esValido(proceso.horasSetupDetalle.polimero)"
          class="setup-item"
        >
          {{ labelsMatriz.tiempo }}: {{ formatearHoras(proceso.horasSetupDetalle.polimero) }}
        </span>
        <span
          v-if="esValido(proceso.horasSetupDetalle.recarga)"
          class="setup-item"
        >
          Recarga: {{ formatearHoras(proceso.horasSetupDetalle.recarga) }}
        </span>
      </div>
    </template>

    <template v-else>
      <div class="sin-maquina-alert">
        <el-alert
          title="Proceso fuera del circuito de cálculo principal"
          type="info"
          show-icon
          :closable="false"
        />
      </div>
    </template>

    <lista-materiales
      v-if="!proceso.esGrupo && proceso.materiales && proceso.materiales.length > 0"
      :materiales="proceso.materiales"
      :is-stale="isStale"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import {
  displayValueConUnidad,
  displayPorcentaje,
  formatearNumero,
  unidadVelocidad,
} from '@/shared/utils/format_produccion.js';
import ListaMateriales from './lista_materiales.vue';
import { completarLabelsMatrizImpresion } from '@/shared/utils/label_matriz_impresion.js';
import {
  completarUnidadTrabajo,
  resolverAbreviaturaMermaFija,
  resolverAbreviaturaUnidadRecurso,
} from '@/shared/utils/unidad_trabajo.js';

const props = defineProps({
  proceso: {
    type: Object,
    required: true,
  },
  isStale: {
    type: Boolean,
    default: false,
  },
});

// COTI-502: Determinar label para polimero
const labelsMatriz = computed(() =>
  completarLabelsMatrizImpresion(props.proceso?.labelsMatrizImpresion),
);

const unidadTrabajo = computed(() => completarUnidadTrabajo(props.proceso?.unidadTrabajo));

const unidadMermaFija = computed(() => resolverAbreviaturaMermaFija(props.proceso));

function dv(valor, unidad, decimales = 2) {
  return displayValueConUnidad(valor, unidad, props.isStale, decimales);
}

function dp(valor) {
  return displayPorcentaje(valor, props.isStale);
}

function formatearHoras(valor) {
  if (props.isStale) return '--';
  const num = Number(valor);
  if (isNaN(num) || num === 0) return '0,00 h';
  return `${formatearNumero(num, 2)} h`;
}

function esValido(valor) {
  if (props.isStale) return false;
  const num = Number(valor);
  return !isNaN(num) && num > 0;
}

function tieneDetalleSetup(detalle) {
  if (!detalle) return false;
  return (
    esValido(detalle.ajuste) ||
    esValido(detalle.color) ||
    esValido(detalle.polimero) ||
    esValido(detalle.recarga)
  );
}
</script>

<style scoped>
.proceso-detalle {
  padding: 8px 0;
}

.data-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 0;
}

.data-label {
  font-size: 11px;
  color: #909399;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.data-value {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  font-family: 'Fira Code', monospace;
}

.merma-text {
  color: #e6a23c;
}

.merma-bold {
  font-weight: 700;
  color: #f56c6c;
}

.text-impresion {
  color: #409eff;
}

.setup-detalle {
  margin-top: 8px;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  font-size: 12px;
}

.setup-label {
  font-weight: 600;
  color: #606266;
}

.setup-item {
  color: #909399;
  font-family: 'Fira Code', monospace;
}

.sin-maquina-alert {
  padding: 8px 0;
}
.merma-absoluta {
  font-size: 11px;
  color: #909399;
  font-weight: 500;
  margin-left: 4px;
}

.merma-desglose {
  margin-top: 8px;
  padding: 8px 12px;
  background: #fdf6ec;
  border-radius: 4px;
  border: 1px solid #faecd8;
  font-size: 12px;
}

.merma-desglose-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 4px 0;
  border-top: 1px dashed #faecd8;
}

.merma-desglose-item:first-of-type {
  border-top: none;
}

.merma-desglose-nombre {
  font-weight: 700;
  color: #606266;
  min-width: 140px;
}

.merma-desglose-valor {
  color: #e6a23c;
  font-family: 'Fira Code', monospace;
}

.merma-desglose-total {
  color: #f56c6c;
  font-weight: 700;
}
</style>
